import { gql } from '@apollo/client'
import { GuildFragment } from '@src/graphql/fragment/guild'

export default gql`
  query GetMyGuild($type: GuildType!) {
    getMyGuildByType(guildType: $type) {
      guild {
        ...Guild
      }
      joinedAt
    }
  }
  ${GuildFragment}
`
